export default "__VITE_ASSET__554db839__"